import React from "react";
import { IconButton, Tooltip, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  iconContainer: {
    position: "absolute",
    bottom: "10px",
    right: "10px",
    display: "flex",
    gap: "8px",
    zIndex: 10,
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    borderRadius: "8px",
    padding: "4px",
  },
  aiIcon: {
    backgroundColor: "#f8f9fa",
    border: "1px solid #e9ecef",
    borderRadius: "8px",
    padding: "8px",
    "&:hover": {
      backgroundColor: "#e9ecef",
      borderColor: "#41B883",
    },
    "&.loading": {
      opacity: 0.7,
      pointerEvents: "none",
    },
  },
  aiIconSvg: {
    width: "18px",
    height: "18px",
    fill: "#6c757d",
  },
});


const stripHtmlTags = (html) => {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, "").trim();
};

const AIJobDescriptionIcons = ({
  onWriteWithAI,
  onRewriteWithAI,
  hasExistingContent = false,
  isLoading = false,
  existingContent = "", 
}) => {
  const classes = useStyles();

 
  const actualContent = stripHtmlTags(existingContent);
  const showRewriteIcon = actualContent && actualContent.length > 15; 

  console.log("AI Icons - Content check:", {
    hasExistingContent,
    existingContent: existingContent?.substring(0, 100),
    actualContent: actualContent?.substring(0, 100),
    showRewriteIcon,
  });

  const WriteIcon = () => (
    <svg className={classes.aiIconSvg} viewBox="0 0 24 24">
      <path d="M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z" />
      <circle cx="18" cy="6" r="3" fill="#41B883" />
      <text
        x="18"
        y="7.5"
        textAnchor="middle"
        fontSize="2.5"
        fill="white"
        fontWeight="bold"
      >
        AI
      </text>
    </svg>
  );

  const RewriteIcon = () => (
    <svg className={classes.aiIconSvg} viewBox="0 0 24 24">
      <path d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z" />
      <circle cx="18" cy="18" r="3" fill="#41B883" />
      <text
        x="18"
        y="19.5"
        textAnchor="middle"
        fontSize="2.5"
        fill="white"
        fontWeight="bold"
      >
        AI
      </text>
    </svg>
  );

  return (
    <div className={classes.iconContainer}>
      <Tooltip title="Write with AI" placement="top">
        <span>
          <IconButton
            className={`${classes.aiIcon} ${isLoading ? "loading" : ""}`}
            onClick={onWriteWithAI}
            disabled={isLoading}
            size="small"
          >
            {isLoading ? (
              <CircularProgress size={18} color="primary" />
            ) : (
              <WriteIcon />
            )}
          </IconButton>
        </span>
      </Tooltip>

      {showRewriteIcon && (
        <Tooltip title="Rewrite with AI" placement="top">
          <span>
            <IconButton
              className={`${classes.aiIcon} ${isLoading ? "loading" : ""}`}
              onClick={onRewriteWithAI}
              disabled={isLoading}
              size="small"
            >
              {isLoading ? (
                <CircularProgress size={18} color="primary" />
              ) : (
                <RewriteIcon />
              )}
            </IconButton>
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export default AIJobDescriptionIcons;
